import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@reservamos/elements';
import { useDispatch } from 'react-redux';
import dotersIcon from '../../images/doters/greendoters.svg';
import { useReserhubAccount } from '../../context/ReserhubAccount';
import useWhitelabelFeatures from '../../hooks/whitelabel/useWhitelabelFeatures';
import reserhubApi from '../../services/reserhub-api/reserhubApi';
import { setAlert } from '../../actions';
/**
 * DotersBannerAccount component.
 * Render Doters points section with menu items.
 * @returns {JSX.Element}
 */
export default function DotersBannerAccount() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { DOTERS_ENABLED } = useWhitelabelFeatures();
  const {
    enabled: reserhubAccountEnabled,
    connectedAccounts,
    isConnectedAccountsLoading,
  } = useReserhubAccount();
  const { t } = useTranslation('loyalty');

  if (
    isConnectedAccountsLoading ||
    !reserhubAccountEnabled ||
    !DOTERS_ENABLED ||
    connectedAccounts.find((account) => account.provider === 'doters')
  )
    return null;

  /**
   * Handle the join free button click
   */
  function handleJoinFree() {
    setIsLoading(true);
    reserhubApi
      .loginWithDoters()
      .then((response) => {
        if (response?.url) {
          window.location.href = response.url;
        } else {
          dispatch(setAlert('reserhub_login_doters_error', 'warning'));
        }
      })
      .catch(() => {
        dispatch(setAlert('reserhub_login_doters_error', 'warning'));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div className="w-fit rounded-full bg-white p-1 shadow-sm flex items-center justify-between gap-2 border border-gray-200">
      <div className="flex items-center gap-2 bg-gray-200 rounded-full">
        <div className="w-8 h-8 min-w-8 min-h-8 shrink-0 rounded-full flex items-center justify-center bg-[var(--loyalty)]">
          <img src={dotersIcon} alt="Doters" className="w-5 h-5" />
        </div>
        <Text size="XS" className="min-w-0 break-words">
          {t('earn_doters_points')}
        </Text>
      </div>
      <Button
        isRounded
        variant="loyalty"
        onClick={() => handleJoinFree()}
        isDisabled={isLoading}
        isLoading={isLoading}
        fontSize="S"
      >
        {t('join_free')}
      </Button>
    </div>
  );
}
